module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2i"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 1")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg",
      "width": "150px"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2title"
  }, [_vm._v("Wanted: Men for a Dangerous and Hazardous Mission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("C")]), _vm._v("harles Newton Hunter was born in Oneida, New York, in January 1906. From an early age, he knew that soldiering was the life for him. He graduated from West Point Military Academy in 1929, in the same class as a young officer from Massachusetts named Frank Dow Merrill.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Hunter was a popular cadet, a lively young man whose traits, and his Scottish ancestry, were described in his entry in "), _c('em', [_vm._v("Howitzer")]), _vm._v(", the West Point yearbook:")])]), _c('p', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "prolog13"
    }
  }, [_vm._v("Newt has worn the gray of the Corps with distinction, yet, we hope sometime to see him in wee kilts, and to hear him dreamily squeeze the bagpipe for our benefit. His ruddy countenance, slightly tilted nose, sandy hair, and twinkling blue eyes carry an appeal that can pass unnoticed by no mortal lass. Fortunately for us, Newt’s forefathers failed to transmit to him their most famous trait. His helpful generosity would do credit to even the Good Samaritan. Newt is a precious bundle of wit and humor, with more than his share of common sense and good fellowship. He is the type that one enjoys to have around and whom you daily learn to appreciate more and more. These characteristics are certain to gain him the best in life wherever he goes.")])]), _c('a', {
    attrs: {
      "id": "prolog13"
    }
  }), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "prolog13"
    }
  }, [_vm._v("From West Point, Hunter joined an infantry regiment. He served three years in the Philippines and two and a half in the Canal Zone, the ribbon of U.S. territory in Panama that included the Panama Canal. Neither posting was challenging. His time was spent instructing soldiers from the 14th ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Infantry in the art of jungle warfare. After the Japanese attack on Pearl Harbor, Hunter was recalled to the States and sent to the infantry school at Fort Benning, Georgia. Now a lieutenant colonel in his thirty-seventh year, Hunter was appointed chief of the Rifles and Weapons Platoon Group of the Weapons Sections—a long-winded title for a tedious position. The war seemed to be passing Hunter by, even if all the training kept him in shape. ")]), _c('a', {
    attrs: {
      "id": "prolog14"
    }
  }, [_vm._v("“Five feet seven and very muscular with no excess fat” was how one contemporary described Hunter. “His athletic appearance and firm facial features created an aura of authority.”")])]), _c('a', {
    attrs: {
      "id": "prolog14"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog14"
    }
  }, [_vm._v("In late August 1943, Hunter was one of several officers who responded to a call from the War Department for a “hazardous mission.” It was a chance to escape the boredom of Fort Benning. When Hunter was summoned to Washington, he had no idea what he gotten himself into. ")]), _c('a', {
    attrs: {
      "id": "prolog15"
    }
  }, [_vm._v("“My only clue,” he wrote later, “was that I had been selected from all other volunteer lieutenant colonels because of my extensive tropical jungle experience.”")])]), _c('a', {
    attrs: {
      "id": "prolog15"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog15"
    }
  }, [_vm._v("Hunter spent a week in Washington, learning all about the hazardous mission code named “Galahad”")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fn01",
      "id": "ch01fn01a"
    }
  }, [_vm._v("*")]), _vm._v(" and the force of three thousand troops that had to be raised in a month. Hunter was also briefed on the complex situation in the China Burma India Theater—the intrigues, the personalities, the egos. Finally, Hunter was informed that the War Department expected the force—which, for the sake of expediency, was designated for the time being the 1688th Casual Detachment—"), _c('a', {
    attrs: {
      "id": "prolog16"
    }
  }, [_vm._v("“would suffer approximately 85% casualties” during its three-month mission.")])]), _c('a', {
    attrs: {
      "id": "prolog16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of the week, Hunter left Washington clutching a set of secret orders and made for Fort Mason, California, where he was to report to the commanding general, San Francisco Port of Embarkation, no later than September 20. Hunter was told that secrecy was paramount and, therefore, they would be sailing “under the not very convincing cover of medical replacements” for the South Pacific Theater.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("As Hunter headed west, a memo was on its way to General Thomas Troy Handy, assistant chief of staff in charge of Operations Division, updating him on the progress of the 1688th Casual Detachment’s recruitment. Dated September 18, it ran:")]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_vm._v("1. The following personnel for the American Long-Range Penetration Units for employment in Burma are being satisfactorily assembled at the San Francisco Port of Embarkation:")])]), _c('p', {
    staticClass: "blocka"
  }, [_c('a', {
    attrs: {
      "id": "prolog16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("960 jungle-trained officers and men from the Caribbean Defense Command")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "blocka"
  }, [_vm._v("970 jungle-trained officers and men from the Army Ground Forces.")]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_vm._v("2. A total of 674 battle-tested jungle troops from the South Pacific are being assembled at Noumea (the capital city of New Caledonia) and will be ready for embarkation on the Lurline 1st October.")]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_vm._v("3. General MacArthur was directed to furnish 274 battle-tested troops. He was able to secure only 55 volunteers meeting our specifications. He was accordingly authorized to secure volunteers from trained combat troops that have not been battle-tested. These troops will be picked up by the Lurline at Brisbane.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Among the volunteers heading to San Francisco were two handpicked by Hunter: Sam Wilson and William Lloyd Osborne. Wilson, a nineteen-year-old first lieutenant, had been raised on a 150-acre tobacco and corn farm in Southside, Virginia. His mother was a public schoolteacher from whom he inherited an abiding love of literature as well as ")]), _c('a', {
    attrs: {
      "id": "prolog17"
    }
  }, [_vm._v("“discipline, self-control, and how to think logically.” From his father, Wilson and his four siblings were imbued with a love of nature and the psychological tools required to survive in the great outdoors.")])]), _c('a', {
    attrs: {
      "id": "prolog17"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog17"
    }
  }, [_vm._v("Wilson, who had lied about his age to enlist in the National Guard in 1940, first came to the attention of Hunter at Fort Benning. Upon graduating from Officer Candidate School in August 1942, Wilson was selected to remain behind as an instructor, imparting his expertise in raiding by infiltration, patrolling, and ambushes. ")]), _c('a', {
    attrs: {
      "id": "prolog18"
    }
  }, [_vm._v("“We taught them out on the sides of the hill or in the swamps and marshes along the Upatoi Creek on the Chattahoochee River,” remembered Wilson. “There was very, very little actual class time and now a whale of a lot of bleacher time.”")])]), _c('a', {
    attrs: {
      "id": "prolog18"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog18"
    }
  }, [_vm._v("Wilson was assigned to the Office of Strategic Services (OSS) in the summer of 1943, just as the 1688th Casual Detachment was initiated. Hunter, recalled Wilson, “invited me to go with him on an unnamed escapade that sounded pretty mysterious.” Wilson had no idea what or where the “escapade” involved, but he trusted Hunter. “He was a lieutenant colonel and, obviously, an extraordinarily capable officer,” remembered Wilson. ")]), _c('a', {
    attrs: {
      "id": "prolog19"
    }
  }, [_vm._v("“He gave me all the responsibility as a young lieutenant that I could handle. So when he asked me if I would like to join him on a rather dangerous mission, there was only one answer.”")])]), _c('a', {
    attrs: {
      "id": "prolog19"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog19"
    }
  }, [_vm._v("The other officer to receive an invitation from Hunter was in marked contrast to the young and inexperienced Wilson. Major William Osborne ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("was the recipient of a Distinguished Service Cross for a feat of extraordinary daring that turned him and another officer into national celebrities in the fall of 1942.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1941, Osborne had commanded a battalion of the Philippine infantry. But following the fall of the Islands in April that year, he fled into the jungles around Bataan, evading the Japanese forces for several months. Eventually, a group of Philippine partisans put Osborne in touch with an escaped Air Force lieutenant, Damon Guase. Together, the pair set sail for Australia in a twenty-two-foot, native-built motorboat with only a "), _c('em', [_vm._v("National Geographic")]), _vm._v(" map and an army field compass to navigate the 3,200 miles of ocean. “We arrived here not by any expert navigation but by the grace of God,” declared Osborne when he stepped ashore in Australia.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The twenty-nine-year-old Osborne, a married man who had been born in Prescott, Arizona, was nothing special to look at. On arriving in San Francisco from Fort Benning—where he had been lecturing students in jungle warfare—a fellow volunteer for the 1688th Casual Detachment was surprised at his appearance. “He reminded me more of a young assistant professor of mathematics than anything else,” wrote Charlton Ogburn, who later was to discover that Osborne possessed a characteristic ")]), _c('a', {
    attrs: {
      "id": "prolog20"
    }
  }, [_vm._v("“rare among those who have actually been through war: he liked battle.”")])]), _c('a', {
    attrs: {
      "id": "prolog20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Lieutenant Ogburn had learned of the call for volunteers while idling away his time at Camp Van Dorn in Mississippi. Serving in the 99th Signal Company, 99th Infantry Division, the thirty-year-old Ogburn was an unlikely recruit to what the War Department had in mind for the 1688th Casual Detachment. He was an intellectual with little military lineage of which to boast; his father was a corporation lawyer and his mother a writer of mystery novels. Ogburn had graduated from Harvard in 1932 and moved to New York City, where he made a respectable living as a writer, including reviewing books for the Book of the Month Club. On the outbreak of war, Ogburn enlisted in the Signal Corps with the ambition of becoming a photographer. Eighteen months down the line, he had yet to lay eyes on a camera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ogburn was alerted to the 1688th Casual Detachment by a fellow officer at Camp Van Dorn. Standing in the chow line, swatting away mosquitoes, Ogburn was told by his buddy that the War Department was seeking “volunteers with jungle training.” That ruled Ogburn out unless, as his messmate joked, Mississippi counted as the jungle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What the hell, thought Ogburn, nothing to lose. He put his name forward, more in hope than expectation, but a few days later he received Special Orders 218, instructing him to report to Camp Stoneman, forty-five miles northeast of San Francisco, on September 17.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog20"
    }
  }, [_vm._v("Ogburn arrived a day ahead of schedule, and when he checked in to a modest hotel he found himself sharing a room with Sam Wilson. Eleven ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("years Ogburn’s junior, Wilson was ")]), _c('a', {
    attrs: {
      "id": "prolog21"
    }
  }, [_vm._v("“ardent and idealistic, yet unfailingly self-possessed, self-disciplined and coolly analytical,” Ogburn wrote. The youngster told Ogburn all he knew about the force being assembled, that it was for a “dangerous and hazardous mission” under the command of the redoubtable Lt. Col. Charles Hunter. The first thing that struck Ogburn was how the hell could a mission be dangerous and "), _c('em', [_vm._v("not")]), _vm._v(" hazardous?")])]), _c('a', {
    attrs: {
      "id": "prolog21"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog21"
    }
  }, [_vm._v("The next day, Ogburn reported to Camp Stoneman. Already wondering if he hadn’t made an awful miscalculation, his heart sank still further when he discovered he was now an infantryman. Then he heard a rumor that a casualty rate of 85 percent was anticipated for whatever the War Department had in mind. The “final and worst blow of the day” came when Ogburn was appointed commander of the communications platoon of Casual Detachment 1688-A, which came to be called 1st Battalion.")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fn02",
      "id": "ch01fn02a"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a Signal Corps officer, Ogburn had trained in field wire and telephone, but his experience of radio was negligible. A crash course awaited him, but in the meantime Ogburn had the opportunity to run an eye over some of the men who would be serving under him in the 1688th Casual Detachment. “I remember the word ‘pirates’ crossed my mind,” he wrote later. "), _c('a', {
    attrs: {
      "id": "prolog22"
    }
  }, [_vm._v("“An assemblage of less-tractable soldiers I had never seen.” One of his fellow officers, Capt. Tom Senff, a former law student from Kentucky who took life in stride, grinned as he eyed up the men. ")]), _c('a', {
    attrs: {
      "id": "prolog23"
    }
  }, [_vm._v("“We’ve got the misfits of half the divisions in the country,” he said.")])]), _c('a', {
    attrs: {
      "id": "prolog23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the men who stood in front of Ogburn was Robert Passanisi. A nineteen-year-old from Brooklyn, Passanisi was the son of Sicilian immigrants, his father a stonemason who had worked on many of the brownstone houses of Brooklyn. Passanisi was the youngest of twelve children and, as a result, grew up tough, ambitious, and with a strong fighting spirit. He was clever, too, and self-confident, excelling at school in science and track and field. When he wasn’t watching the Brooklyn Dodgers, Passanisi helped repair neighborhood radios.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Passanisi enlisted in April 1942 after watching newsreel footage of the fall of Bataan. He was underage, but his height (he was over six feet), plus a little tampering with his birth certificate, fooled the Army. Having qualified as an aircraft radio equipment repairman, technician fifth grade (T5), Passanisi was posted to the 76th Signal Company at Camp A.P. Hill.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog23"
    }
  }, [_vm._v("For months, Passanisi chafed at the torpor of life in Virginia. He had brothers fighting in Europe, and here was he, wasting away in the States. Then one Friday afternoon in September 1943, the 245 men of his signal company were addressed by the first sergeant. ")]), _c('a', {
    attrs: {
      "id": "prolog24"
    }
  }, [_vm._v("“He proceeded to read a request for ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("volunteers,” remembered Passanisi. “He explained that the mission would be for six months—three months training and a three-month mission. I don’t remember hearing the words "), _c('em', [_vm._v("dangerous")]), _vm._v(" or "), _c('em', [_vm._v("hazardous")]), _vm._v(", but he did say casualties were expected to be very high.” The sergeant asked for volunteers. Passanisi needed no second invitation. “As I stepped forward, I looked around and was amazed to see that of the 245 men, I was the only volunteer.”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Over the weekend, Passanisi was restricted to company area. Then early Monday morning, he was put on a train to San Francisco, a journey that gave him plenty of time to reflect on his decision to swap an easy life for an unknown one. ")]), _c('a', {
    attrs: {
      "id": "prolog25"
    }
  }, [_vm._v("“There are many reasons that swirl around in a soldier’s mind that lead to a decision to volunteer for some life-threatening mission,” he said. “The great majority did so because they were young and adventuresome, restless and desirous of getting involved more actively in the war.”")])]), _c('a', {
    attrs: {
      "id": "prolog25"
    }
  }), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "id": "prolog25"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fn01a",
      "id": "ch01fn01"
    }
  }, [_vm._v("*")]), _vm._v("“Galahad” remained a classified code name for many months and was not known among its volunteers.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fn02a",
      "id": "ch01fn02"
    }
  }, [_vm._v("*")]), _vm._v("Some Marauders never got out of the habit of referring to the battalions by “A,” “B,” and “C,” but for the sake of clarity, this author will use the official 1st, 2nd, and 3rd appellation.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0